module.exports = __webpack_public_path__ + "img/television.ca532e5e.webp";